<div class="min-h-screen bg-transparent dark:bg-dark overflow-hidden">
    <sidebar></sidebar>
    <div [class]="(isCollapsed$ | async) ? 'md:ml-24' : 'md:ml-[14rem]'" class="transition-all duration-300"
        [class.pb-20]="isMobile()">
        <app-header></app-header>
        <main class="p-6">
            <router-outlet></router-outlet>
        </main>
    </div>

    <!-- Mobile bottom bar (PWA only) -->
    <bottom-bar *ngIf="isStandalone()" (fabTapped)="toggleForm()"></bottom-bar>


    <!-- iOS install prompt -->
    <ios-install-prompt></ios-install-prompt>

    <!-- Layout-level transaction form (triggered by mobile FAB) -->
    <transaction-form class="fixed w-full max-w-md mx-auto z-[9999]" *ngIf="isFormVisible && isMobile()"
        (formClosed)="toggleForm()" (formSubmitted)="onFormSubmit($event)" (promptSubmitted)="onPromptSubmit($event)">
    </transaction-form>
</div>